import React, { useState } from 'react'
import { Link } from 'react-router-dom'

function ExperienceItem({ title, started, location, workType, isCompleted, responsibilities, ended, tags=[], tech=[], company, extra, video, link ,image }) {

    const [isVideoShow, setIsVideoShow] = useState(false)

  return (
    <div id={title} className={`w-full bg-zinc-800 rounded-lg flex flex-col items-center border border-zinc-700 p-3 mb-4`}>
        <div className='w-full text-left flex flex-row items-center justify-between space-x-2'>
            <p className='text-zinc-300 text-sm'>{location}</p>
            <p className='text-zinc-300 text-sm'>{started} - {isCompleted?ended:'Present'}</p>
        </div>
        <div className='w-full flex flex-col lg:flex-row items-start lg:items-center justify-between'>
            <h4 className='w-full flex items-start flex-wrap flex-row text-left text-white lg:space-x-2 py-2 text-sm'>
                <span className='text-zinc-200 text-lg font-semibold'>{title}</span> <span className='text-zinc-400 text-lg lg:px-0 px-2'>at</span> <span className='text-zinc-200 text-lg font-semibold'>{company}</span>
            </h4>
            {workType&&(<span className='bg-green-600 text-zinc-800 font-medium rounded-full px-2 py-1 text-xs whitespace-nowrap'>{workType}</span>)}
        </div>     
        <div className='w-full text-left flex flex-col items-center space-y-2 text-base py-2 mb-1'>
            {
                responsibilities?.map(i => (
                    <p className='w-full rounded-lg bg-gradient-to-r from-zinc-900/70 px-2 py-1.5 text-zinc-400'>{i}</p>
                ))
            }
        </div>
        <div className='w-full overflow-x-hidden flex-wrap flex flex-row items-center mb-2 space-y-1'>
            {tech?.map(i => <span className='whitespace-nowrap rounded-full border border-zinc-600 mx-1 bg-transparent text-sm text-zinc-300 px-2'>{i}</span>)}
        </div>
    </div>
  )
}

export default ExperienceItem